const emailConfig = {
    QUESTIONS: {
        TYPE_OF_PLANT:{
            question: "Plant Type?",
            key: "isManual",
            nudge: "Customer ka Plant Manual h ya Automatic h?",
            options: [
                {
                    displayName: "Manual",
                    key: "yes",
                    value: true
                },
                {
                    displayName: "Automatic",
                    key: "no",
                    value: false
                },
            ],
        },
        NO_ISSUE_FOUND:{
            question: "No issue found in sevice, machine is in okay condition?",
            key: "isMachineOkay",
            nudge: "Kya machine / plant / gun sab thik tha, koi issue nhi mila, OK service hain?",
            options: [
                {
                    displayName: "Yes",
                    key: "yes",
                    value: true
                },
                {
                    displayName: "No",
                    key: "no",
                    value: false
                },
            ],
        }
        ,
        DAMAGED_COMPONENTS: {
            question: "Did you find any damaged components?",
            key: "isDamagedComponentAvailable",
            nudge: "Kya koi spare damaged h?",
            options: [
                {
                    displayName: "Yes",
                    key: "yes",
                    value: true
                },
                {
                    displayName: "No",
                    key: "no",
                    value: false
                },
            ],
            showSpareDropdown:true
        },
        RECOMMENDED_COMPONENTS: {
            question: "Recommended spare parts for avoiding future breakdown?",
            key: "isRecommendedComponentAvailable",
            nudge: "Kya aap customer ko vo spare parts bhi bhejna chahte hain jinhe customer ko apne stock me rakhna chaiye?",
            options: [
                {
                    displayName: "Yes",
                    key: "yes",
                    value: true
                },
                {
                    displayName: "No",
                    key: "no",
                    value: false
                },
            ],
            showRecommendedSpareDropdown:true
        },
        NEARLY_DAMAGED_COMPONENT: {
            question: "Did you find any components that are non-damaged but will be damaged in some days/months?",
            key: "isNearlyDamagedComponentAvailable",
            nudge: "kya koi asa spare h jo abhi to shi chal rha h pr kuch din me khrab ho skta h?",
            options: [
                {
                    displayName: "Yes",
                    key: "yes",
                    value: true
                },
                {
                    displayName: "No",
                    key: "no",
                    value: false
                },
            ]
        },
        NON_DAMAGED_BUT_OLD_COMPONENT: {
            question: "Did you find any components that non-damaged but should be replaced as these that are too old, and Gema recommeds to replace in certain period?",
            key: "isNonDamagedButOldComponentAvailable",
            nudge: "kya koi asa spare h jo shi h pr kafi purana h magar change ho jana chaiye?",
            options: [
                {
                    displayName: "Yes",
                    key: "yes",
                    value: true
                },
                {
                    displayName: "No",
                    key: "no",
                    value: false
                },
            ]
        },
        PLANT_CONDITION: {
            question: "Is the plant / gun / machine is in running condition?",
            key: "isPlantRunning",
            nudge: "kya plant / gun / machine working h?",
            options: [
                {
                    displayName: "Yes",
                    key: "yes",
                    value: true
                },
                {
                    displayName: "No",
                    key: "no",
                    value: false
                },
            ]
        },
        DUPLICATE_SPARES: {
            question: "The company is using local/duplicate spares in machine?",
            key: "isUsingDuplicateSpares",
            nudge: "kya aapko duplicate / local spare mile jo customer use kr rha h, aur use nhi krne chaiye?",
            options: [
                {
                    displayName: "Yes",
                    key: "yes",
                    value: true
                },
                {
                    displayName: "No",
                    key: "no",
                    value: false
                },
            ]
        },
        PAST_SPARE_PURCHASED: {
            question: "The company did not purchased the spares in certain period?",
            key: "isPastSparePurchaseNotDone",
            nudge: "Kya client ne kafi time se spare nhi liye jo use lene chaiye the?",
            options: [
                {
                    displayName: "Yes",
                    key: "yes",
                    value: true
                },
                {
                    displayName: "No",
                    key: "no",
                    value: false
                },
            ]
        },
        IMPACT_ON_COST: {
            question: "Do you want customer to know that we can provid the detailed report on costing or his loss as well?",
            key: "isCostOnImpact",
            nudge: "Kya app client to ye bhi bhejna chaite hai h ki vo detail report bhi bnva skte hain for costing and imact?",
            options: [
                {
                    displayName: "Yes",
                    key: "yes",
                    value: true
                },
                {
                    displayName: "No",
                    key: "no",
                    value: false
                },
            ]
        },
        KEYPOINTS:{
            question: "Do you want to add Generic term and condition for Machine Life?",
            key: "isGenTerms",
            nudge: "Kya app email normal ye bhi btana chate hin ki spares shi time pe na badalne se kya kya issue ho skta h ?",
            options: [
                {
                    displayName: "Yes",
                    key: "yes",
                    value: true
                },
                {
                    displayName: "No",
                    key: "no",
                    value: false
                },
            ]
        }
    },
    LANGUAGES: {
        COMMUNICATION_STARTER: {
            heading: "",
            content: [
                "I hope this email finds you in good health. Following our recent visit to your facility, we conducted a thorough inspection of your powder coating plant / gun  and machinery. Below are our findings and recommendations:",
            ]
        },
        NO_ISSUE_FOUND:[
            "All inspected components and systems are functioning optimally.",
            "No signs of wear or damage were observed in critical parts."
        ],
        
        DAMAGED_HEAD: [
            "Damaged: "
        ],
        DAMAGED_SPARE_LIST_CONTENT: [
            "During the servicing of the machines, we identified several damaged or malfunctioning spare parts that require immediate replacement. Specifically, the following component needs urgent attention:  "
        ],
        DAMAGED_SPARE_GEN_CONTENT: [
            "During the service of the machines we have found some spares that are damaged or not working properly. These components needs to be replaced as soon as possible. We will send the list of the components with quotation at earliest so that you will not face any problem."
        ],

        INTACT_HEAD:["Intact but Require Replacement:"],
        INTACT_SPARE_LIST_CONTENT: [
            "During the service of the machines we have found some spare that are not damaged but need earliest attention. These components are SELECTED_INTACT_SPARE"
        ],
        INTACT_SPARE_GEN_CONTENT: [
            "During the service of the machines we have found some spare that are not damaged but need earliest attention. . We will send the list of the components with quotation at earliest so that you will not face any problem."
        ],



        NEARLY_DAMAGED_COMPONENT: [],
        NON_DAMAGED_BUT_OLD_COMPONENT: [
            "Upon review/discussion, some materials have not been replaced as recommended by Gema for optimal efficiency. These will cause issues in the future. please replace them with new original spares."
        ],
        PLANT_CONDITION: [],
        DUPLICATE_SPARES: [
            "We have identified some materials, such as $DUPLICATE_SPARES$, that are not original and may cause future issues, potentially leading to plant / gun / machine failure. Please address this and replace these with original components."
        ],
        PAST_SPARE_PURCHASED: [],
        IMPACT_ON_COST: [
            "If desired, we can conduct a comprehensive report detailing the impact on costs, production, efficiency, and duration. This will help you understand the necessary improvements."
        ],


        OVERALL_PLANT_CONDITION: {
            heading: "Overall Plant / Gun /Machine Condition:",
            OPERATIONAL: {
                content: [
                    "While it is commendable that the machine is currently operational, it is crucial to address the components in poor condition to ensure continued efficiency.",
                ]
            },
            NON_OPERATIONAL: {
                content: [
                    "The Plant / Gun / Machine is in non-Operational and the listed components/spares are required to make the machine operational again.",
                ]
            },
            NO_ISSUE_FOUND:{
                content: [
                    "Your machinery is in excellent working condition, reflecting the effectiveness of your regular maintenance practices.",
                ]
            }

        },
        PAST_MATERIAL_PURCHASED: {
            heading: "Past Material Purchased:",
            content: [
                "Upon review/discussion, some materials have not been replaced as recommended by Gema for optimal efficiency. These will cause issues in the future. please replace them with new original spares.",
            ]
        },
        LOCAL_MATERIAL_FOUND: {
            heading: "Local / Non-original Materials Found:",
            content: [
                "We also discovered some non-original materials that could lead to future issues, potentially causing plant / gun / machine failure. It is advisable to replace these with original components to avoid such risks.",
            ]
        },
        KEYPOINTS: {
            heading: "Considerations for Maintaining a Healthy Plant / Gun / Machine:",
            content: [
                "* Damaged or malfunctioning components can lead to plant / gun / machine failure.",
                "* This will impact plant / gun / machine efficiency (daily production).",
                "* Increased powder consumption per component will raise costs.",
                "* Non-original components can degrade machine performance.",
                "* Production times may increase.",
                "* Please be advised that due to the presence of local or non-original materials identified during any inspection, we will not be able to provide further service, and any existing warranty will be terminated.",
            ]
        },
        IMPACT_ASSESSMENT_OF_PLANT: {
            heading: "Impact Assessment on Plant / Gun / Machine:",
            content: [
                "If you wish, we can provide a detailed report outlining the potential impact on costs, production, efficiency, and overall operational duration. This will help clarify the necessary improvements.",
            ]
        },
        GUN_MAINTENANCE_MANUAL:{
            heading: "Gun Maintenance and cleaning procedure (Click on Link):",
            content: [
                "https://drive.google.com/file/d/150I27vYhzTG1Zal36NM37AopBBwvYEGS/view",
            ]
        },
        RECOMMENDED_LINE: {
            heading: "",
            content: [
                "We strongly recommend addressing these issues promptly to maintain optimal plant / gun / machine performance and prevent future problems.",
            ]
        },
        FEEL_FREE_TO_CONNECT: {
            heading: "",
            content: [
                "Please feel free to contact us if you have any questions or need further assistance.",
            ]
        },
    },
    LANGUAGE_KEYS: {
        COMMUNICATION_STARTER: "COMMUNICATION_STARTER",

        DAMAGED_HEAD: "DAMAGED_HEAD",
        DAMAGED_SPARE_LIST_CONTENT: "DAMAGED_SPARE_LIST_CONTENT",
        DAMAGED_SPARE_GEN_CONTENT: "DAMAGED_SPARE_GEN_CONTENT",
        SELECTED_DAMAGED_SPARE:"SELECTED_DAMAGED_SPARE",

        SPARE_1:"SPARE_1",
        SPARE_2:"SPARE_2",
        SPARE_3:"SPARE_3",
        SPARE_4:"SPARE_4",
        SPARE_5:"SPARE_5",
        SPARE_6:"SPARE_6",
        SPARE_7:"SPARE_7",
        SPARE_8:"SPARE_8",
        SPARE_9:"SPARE_9",

        INTACT_HEAD:"INTACT_HEAD",
        INTACT_SPARE_LIST_CONTENT: "INTACT_SPARE_LIST_CONTENT",
        INTACT_SPARE_GEN_CONTENT: "INTACT_SPARE_GEN_CONTENT",
        SELECTED_INTACT_SPARE:"SELECTED_INTACT_SPARE",

        OVERALL_PLANT_CONDITION_HEAD: "OVERALL_PLANT_CONDITION_HEAD",
        OVERALL_PLANT_CONDITION_OPERATIONAL: "OVERALL_PLANT_CONDITION_OPERATIONAL",
        OVERALL_PLANT_CONDITION_NON_OPERATIONAL: "OVERALL_PLANT_CONDITION_NON_OPERATIONAL",
        PAST_MATERIAL_PURCHASED_HEAD: "PAST_MATERIAL_PURCHASED_HEAD",
        PAST_MATERIAL_PURCHASED_CONTENT: "PAST_MATERIAL_PURCHASED_CONTENT",
        LOCAL_MATERIAL_FOUND_HEAD: "LOCAL_MATERIAL_FOUND_HEAD",
        LOCAL_MATERIAL_FOUND_CONTENT_LIST:"LOCAL_MATERIAL_FOUND_CONTENT_LIST",
        LOCAL_MATERIAL_FOUND_CONTENT: "LOCAL_MATERIAL_FOUND_CONTENT",
        KEYPOINTS_HEAD: "KEYPOINTS_HEAD",
        KEYPOINTS_1: "KEYPOINTS_1",
        KEYPOINTS_2: "KEYPOINTS_2",
        KEYPOINTS_3: "KEYPOINTS_3",
        KEYPOINTS_4: "KEYPOINTS_4",
        KEYPOINTS_5: "KEYPOINTS_5",
        KEYPOINTS_6: "KEYPOINTS_6",
        IMPACT_ASSESSMENT_OF_PLANT_HEAD: "IMPACT_ASSESSMENT_OF_PLANT_HEAD",
        IMPACT_ASSESSMENT_OF_PLANT_CONTENT: "IMPACT_ASSESSMENT_OF_PLANT_CONTENT",
        RECOMMENDED_LINE: "RECOMMENDED_LINE",
        FEEL_FREE_TO_CONNECT: "FEEL_FREE_TO_CONNECT",
        ENGINEER_NAME: "ENGINEER_NAME",
        ENGINEER_DESIGNATION: "ENGINEER_DESIGNATION",
        ENGINEER_CONTACT_NUMBER:"ENGINEER_CONTACT_NUMBER",
        ENGINEER_OFFICAIL_EMAIL:"ENGINEER_OFFICAIL_EMAIL",
        GUN_MAINTENANCE_MANUAL:"GUN_MAINTENANCE_MANUAL",
        GUN_MAINTENANCE_MANUAL_HEAD:"GUN_MAINTENANCE_MANUAL_HEAD"
    }
}

module.exports = emailConfig